<template>
    <section>

        <!-- LOGIN -->

        <div class="row" v-if="!isLoggedIn">
            <div class="kedvenciam_all_area">
                <div class="col-sm-12">
                    <div class="single_kedvenciam_all stop_bor">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="last_small_box">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="ked_menu_box">
                                                <div class="ked_menu_box_cont">
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="szem_title">
                                                                <p>Folytatás bejelentkezés után</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="kedvenciam_all_area for_nw_form">
                                            <div class="col-sm-12">
                                                <div class="single_kedvenciam_all" style="padding-right:0;padding-left:0">
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="thm_last_btn text-center">
                                                                <router-link tag="a" to="/login?order=true" class="reg-class">Bejelentkezés / Regisztráció</router-link>
                                                            </div>
                                                        </div>
                                                        <p style="margin-top:50px;padding-right:15px;padding-left:15px">
                                                            Ajánljuk, hogy jelentkezz be a vásárlásod könnyebb nyomonkövetése és a következő vásárlásaid megkönnyítése érdekében.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-6">
                                <div class="last_small_box">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="ked_menu_box">
                                                <div class="ked_menu_box_cont">
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="szem_title">
                                                                <p>Folytatás bejelentkezés nélkül</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="kedvenciam_all_area for_nw_form">
                                            <div class="col-sm-12">
                                                <div class="single_kedvenciam_all">
                                                    <div class="row">
                                                        <div class="col-sm-3">
                                                            <div class="vezteknev_title">
                                                                <h6>E-mail cím*:</h6>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-9">
                                                            <div class="form-group">
                                                                <input class="form-control" type="email" placeholder="" required="" v-model="email" @input="emailChanged">
                                                                <span>{{emailValidText}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- LOGIN END -->

        <div class="row">
            <div class="col-sm-12">
                <div class="ked_menu_box">
                    <div class="ked_menu_box_cont">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="szem_title">
                                    <p>SZÁMLÁZÁSI ADATOK</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <data-view ref="data1" :data="wrapper.invoicingData"></data-view>


        <section >
            <div class="row">
                <div class="col-sm-12">
                    <div class="ked_menu_box">
                        <div class="ked_menu_box_cont">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="szem_title">
                                        <p>SZÁLLÍTÁSI ADATOK</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-9">
                                <div class="vezteknev_title">
                                    <h6>Szállítási adatok megegyeznek a számlázási adatokkal</h6>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <input class="cb-shipping" type="checkbox" placeholder="" v-model="wrapper.sameInvoicingShipping">
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <data-view ref="data2" v-if="!wrapper.sameInvoicingShipping" :data="wrapper.shippingData"></data-view>
        </section>


        <!--newwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww-->


        <!-- <div class="row">
            <div class="kedvenciam_all_area">
                <div class="col-sm-12">
                    <div class="single_kedvenciam_all stop_bor">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="last_small_box"> -->
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="ked_menu_box">
                                                <div class="ked_menu_box_cont">
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="szem_title">
                                                                <p>SZÁLLÍTÁSI MÓD</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <form>

                                    <div class="row">
                                        <div class="kedvenciam_all_area for_nw_form">
                                            <div class="col-sm-12">
                                                <div class="single_kedvenciam_all mobile-padding">
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="hazho">
                                                                <div class="hazho_box" :class="{'disabled-cb':$store.getters.getBasket.priceTotalWithPackage < 5000}">
                                                                    <div>
                                                                        <input :disabled="$store.getters.getBasket.priceTotalWithPackage < 5000" id="radioship-99" class="radio-custom" name="radio-group" value="999" type="radio" v-model="shipping">
                                                                        <label for="radioship-99" class="radio-custom-label"><span>Házhozszállítás, min. 5000 Ft rendelési érték felett</span> (+ {{($store.getters.getBasket.priceTotalWithShipping-$store.getters.getBasket.priceTotalWithPackage).toLocaleString('hu')}} Ft)</label>
                                                                    </div>
                                                                    <div >
                                                                        <span style="margin-right:20px;">Törésbiztosítás igénylése (+ {{(($store.getters.getBasket.priceTotalWithShipping-$store.getters.getBasket.priceTotalWithPackage)*0.75).toFixed(0).toLocaleString('hu')}} Ft):</span>
                                                                        <input :disabled="$store.getters.getBasket.priceTotalWithPackage < 5000" class="cb-shipping" type="checkbox" placeholder="" v-model="crackAssistance">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="atv">
                                                                <p>Személyes átvétel</p>
                                                            </div>
                                                            <div class="x_karulet">

                                                                <div class="row">
                                                                    <div class="col-sm-3" v-for="(s,i) in shops">
                                                                        <div class="row">
                                                                            <div class="col-xs-12 x_karulet_box">
                                                                                <div>
                                                                                    <input :id="'radioshop-'+i" class="radio-custom" name="radio-group" type="radio" :value="s.id" v-model="shipping">
                                                                                    <label :for="'radioshop-'+i" class="radio-custom-label"><span>{{s.name}}</span></label>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-xs-2">

                                                                            </div>
                                                                            <div class="col-xs-10">
                                                                                <p>{{s.location.address}}</p>
                                                                                <p v-if="s.shippingDays != null && s.shippingDays.length>0">Kiérkezési idő: {{s.shippingDays}} nap</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>

                                    </div>
                                <!-- </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div> -->


        <!-- <div class="col-sm-12"> -->
            <!-- <div class="last_small_box"> -->
                <div class="row">
                    <div class="col-sm-12">
                        <div class="ked_menu_box">
                            <div class="ked_menu_box_cont">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="szem_title">
                                            <p>FIZETÉSI MÓD</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <form>
                <div class="row">
                    <div class="kedvenciam_all_area for_nw_form">
                        <div class="col-sm-12">
                            <div class="single_kedvenciam_all now_lil_less">
                                <!-- <div class="row" v-if="shipping && shipping != 999">
                                    <div class="col-xs-2">
                                        <div class="green_mark">
                                            <div class="green_mark_box">
                                                <div>
                                                    <input id="radio-100" class="radio-custom" name="radio-group" type="radio" value="LOCAL" v-model="payment">
                                                    <label for="radio-100" class="radio-custom-label"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xs-10">
                                        <div class="new_gren_box">
                                            <p>Készpénz vagy bankkártya (személyes átvételkor)</p>
                                        </div>
                                    </div>


                                </div> -->
                                <div class="row">
                                    <div class="all_cards">
                                        <!-- <div class="col-xs-2">
                                            <div class="green_mark_box">
                                                <div>
                                                    <input id="radio-101" class="radio-custom" name="radio-group" type="radio" value="ONLINE" v-model="payment">
                                                    <label for="radio-101" class="radio-custom-label"></label>
                                                </div>
                                            </div>
                                        </div> -->

                                        <div class="col-xs-12 text-center">
                                            Online bankkártyás fizetés<br />
                                            <a href="https://kh.hu/" target="_blank"><img src="images/kh.png" alt=""></a>

                                            <div class="cards_box">
                                                <div class="card_box_lists">
                                                    <ul>
                                                        <li><a><img src="images/crd1.png" alt=""></a></li>
                                                        <li><a><img src="images/crd2.png" alt=""></a></li>
                                                        <li><a><img src="images/crd3.png" alt=""></a></li>
                                                        <li><a><img src="images/crd4.png" alt=""></a></li>
                                                        <li><a><img src="images/crd5.png" alt=""></a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <!-- </div> -->
        <!-- </div> -->


        <div class="row">
            <div class="kedvenciam_all_area">
                <div class="col-sm-12">
                    <div class="single_kedvenciam_all again_bg_secnd">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="thm_last_btn text-right">
                                    <a @click="placeOrder">RENDELÉS LEADÁSA</a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Data from '@pages/dashboard/profile/Data.vue'
// import LoginForm from '@commons/LoginForm.vue'
import Endpoints from '@commons/communication/endpoints.js'

export default{
    mixins:[Endpoints],
    components:{
        DataView:Data,
        // LoginForm
    },
    computed: {
        isLoggedIn:function () {
            return this.$store.getters.isLoggedIn;
        }
    },
    data:function () {
        return {
            wrapper:{
                invoicingData:{},
                shippingData:{},
                sameInvoicingShipping:false,
            },
            email: '',
            emailValidText: '',
            shops: [],
            shipping: 0,
            shippingComment: '',
            payment: 'ONLINE',
            crackAssistance:false,
        };
    },
    watch: {
        shipping:function (val) {
            if (val != 999){
                this.crackAssistance = false;
            }
        }
    },
    created:function () {
        var self = this;
        if (this.$store.getters.isLoggedIn){
            this.connDataGet(function (r) {
                self.wrapper = r.data
            })
        }
        this.connShopsGet(function (r) {
            self.shops = r.data.list;
        })
    },
    methods:{
        emailChanged:function () {
            var self = this;
            this.connCheckTempEmail(this.email,function (r) {
                if (r.data.message == 'true'){
                    self.emailValidText='Az email cím megfelelő'
                }else{
                    self.emailValidText ='Az email cím formátuma nem megfelelő vagy már egy regisztrált felhasználóhoz tartozik'
                }
            })
        },
        placeOrder:function () {
            var self = this;

            this.$refs.data1.$validator.validateAll().then(function (ok) {
                if (ok){
                    if (!self.wrapper.sameInvoicingShipping){
                        self.$refs.data2.$validator.validateAll().then(function (ok) {
                            console.log(ok);
                            if (ok){
                                self.placeOrderValidData()
                            }else{
                                toastr.warning('Néhány adat helytelenül lett kitöltve, kérlek ellenőrizd.')
                            }
                        })
                        .catch(function () {
                        })
                    }else{
                        self.placeOrderValidData()
                    }
                }else{
                    toastr.warning('Néhány adat helytelenül lett kitöltve, kérlek ellenőrizd.')
                }
            })
            .catch(function () {
            })
        },
        placeOrderValidData:function () {
            console.log('validation ok');
            var self = this;

            var order = {}
            order.invoicingData = this.wrapper.invoicingData;
            if (this.wrapper.sameInvoicingShipping){
                order.shippingData = this.wrapper.invoicingData;
            }else{
                order.shippingData = this.wrapper.shippingData
            }

            if(this.shipping == 0){
                toastr.warning('Válassz kiszállítási módot');
                return;
            }else{
                if (this.shipping == 999){
                    order.shipping = {
                        crackAssistance: this.crackAssistance,
                        shippingMode: 'SHIPPING',
                        comment: this.shippingComment
                    }
                }else{
                    order.shipping = {
                        shippingMode: 'SHOP_PICK_UP',
                        comment: this.shippingComment,
                        pickUpShop: {
                            id: this.shipping
                        }
                    }
                }
            }

            if(this.payment == ''){
                toastr.warning('Válassz fizetési módot')
            }else{
                order.payment= {
                    paymentMode: this.payment
                }
            }

            var email = null
            var orderBasketToken = null

            if (!this.isLoggedIn){
                email = this.email;
            }
            if (this.$store.getters.getOrderBasketToken != null){
                orderBasketToken = this.$store.getters.getOrderBasketToken;
            }

            this.connOrderPlace(order,orderBasketToken,email,function (r) {
                self.$store.commit('setBasket',{
                    basketElements:[],
                    productExtra:{}
                });
                self.$store.commit('setOrderBasketToken',null);

                if (r.data.message != 'OK'){
                    window.location = r.data.message
                }else{
                    self.$router.push('/checkout/final?txid=nopay');
                }
            },function (r) {
                toastr.error('A rendelés leadása nem sikerült. Kérlek vedd fel velünk a kapcsolatot!',r.data.message)
            })


        }
    }
}


</script>

<style>
input[type=checkbox] {
  transform: scale(1.5);
}
@media(max-width:767px){
  .mobile-padding{
      padding: 20px !important;

  }
}
.reg-class{
    font-size:4vw!important;
}
@media(min-width:400px){
    .reg-class{
        font-size: 16px!important;
    }
}
.disabled-cb{
    opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// FlowData.vue?265b156b